import React, { memo } from 'react'
import { clsx } from 'clsx'

import css from './Heading.module.scss'

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
export type HeadingSize = 'xl' | 'lg' | 'md' | 'sm' | 'xs'

interface HeadingProps {
  /** Semantic level. Pick this from the document outline, not from how big it should look. */
  as: HeadingTag
  /** Visual size. Defaults to the size that matches `as`, so existing call sites keep working. */
  size?: HeadingSize
  children: React.ReactNode
  className?: string
}

// Default look for each level. Pass `size` to break the pairing when the
// outline and the visual hierarchy legitimately disagree.
const SIZE_FOR_TAG: Record<HeadingTag, HeadingSize> = {
  h1: 'xl',
  h2: 'lg',
  h3: 'md',
  h4: 'sm',
  h5: 'sm',
  h6: 'xs'
}

function Heading({ as, size, children, className }: HeadingProps) {
  const Tag = as
  const resolvedSize = size ?? SIZE_FOR_TAG[as]

  return <Tag className={clsx('Heading', css.root, css[resolvedSize], className)}>{children}</Tag>
}

export default memo(Heading)
